module.exports = __webpack_public_path__ + "img/ic_music_dic.bc3b9084.png";